//Funciones
import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useAlert } from "../context/AlertContext";
import { useNavigate } from "react-router-dom";

//CSS
import "../css/Navbar.css";

const Navbar = ({ setIsLoggedIn }) => {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const URL_API = process.env.REACT_APP_URL_API || 'http://localhost:5000';
  const handleLogout = async () => {
    try {
      const userSession = localStorage.getItem("userSession");

      if (userSession) {
        const response = await axios.post(URL_API+"auth/logout", {
          correo: userSession,
        });

        if (response.data.success) {
          localStorage.removeItem("userSession");
          localStorage.removeItem("tipoSession");
          localStorage.removeItem("tokenSession");

          setTimeout(() => {
            setIsLoggedIn(false);
            showAlert("Sesión cerrada correctamente", "success");
            navigate("/");
          }, 1000);
        } else {
          showAlert(response.data.message, "error");
        }
      }
    } catch (error) {
      showAlert("Error al conectar con el servidor", "error");
    }
  };

  return (
    <nav className="navbar">
      <p></p>

      <div className="navbar-logo">
        <img src="/images/faviconBW.png" alt="Logo" />
      </div>

      <ul className="navbar-menu">
        <li>
          <Link to="/">Gestionar Horarios</Link>
        </li>
        <li>
          <Link to="/usuario">Gestionar Usuarios</Link>
        </li>
        <li>
          <Link to="/reporte/1">Reporte Aula</Link>
        </li>
        <li>
          <Link to="/incidencias/1">Reporte Incidencias</Link>
        </li>
      </ul>

      <button className="logout-button" onClick={handleLogout}>
        Cerrar Sesión
      </button>

      <p></p>
    </nav>
  );
};

export default Navbar;
